const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Upload Image component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {S3Uploads} S3Uploads injected to gain access to the s3-uploads resource for s3 file uploading
 * @argument {Upload} Upload injected to gain access to the ng-upload component
 * @argument {$document} $document injected to gain access to the window.document object
 */

app.directive('uploadImage', ['Application', 'S3Uploads', 'Upload', function(Application, S3Uploads, Upload) {
    return {
      restrict: 'A',
      replace: false,
      scope: {
        uploadImage: '=',
        imageLoading: '=',
        loadingPercent: '=',
        filename: '='
      },
      link: function(scope, element, attrs) {
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/png, image/jpeg, image/gif';
        input.setAttribute('class', ( isIE11 ? 'coverInput' : '' ) );

        element[0].addEventListener('click', function() {
          input.click();
        });

        input.addEventListener('change', function(event) {
          var file = event.target.files[0];

          if (!file) {
            return;
          }

          if (file.size > 6291456){
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'Max file size is 6MB.'});
            this.value = "";
            scope.$apply();
            return;
          };

          scope.imageLoading = true;
          scope.loadingPercent = 0;
          scope.$apply();

          if(file.type === '') {
            file.type = 'application/octet-stream';
          }

          S3Uploads.imagePolicy({fileName: file.name, contentType: file.type}, function(data) {
            var cloudFrontLink = data.CloudFrontLink;
            Upload.upload({
              url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
              headers: {'Remove-auth': 'yes'},
              method: 'POST',
              data: {
                key: data.Key,
                'Content-Type': data.ContentType,
                AWSAccessKeyId: data.AWSAccessKeyId,
                'success_action_status': '201',
                policy: data.S3Policy,
                signature: data.S3Signature
              },
              file: file
            }).progress(function(evt) {
              var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
              scope.loadingPercent = percent;
            }).success(function(data) {
              scope.filename = file.name;
              scope.imageLoading = false;
              scope.uploadImage = cloudFrontLink;
              input.value = "";
            }).catch(function(error) {
              input.value = "";
              console.log('upload error', error);
            });
          }, function(error) {
            console.log('s3url error', error);
            Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
          });
        });

        if (isIE11){
          element[0].style.position = "relative";
          element[0].appendChild(input);
        }

      }
    };
  }]);
